var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStableDiaryViewEntries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stable_diary_view_entries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: -0.22,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stable_diary_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.31.93a16.94,16.94,0,0,0-17,16.87V428.65a16.94,16.94,0,0,0,17,16.87H582.19a16.94,16.94,0,0,0,17-16.87V17.8a16.94,16.94,0,0,0-17-16.87",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.24,
    y: 77.07,
    width: 380.92,
    height: 444.6,
    rx: 16.79,
    fill: "#83d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,271.14V582.88a17,17,0,0,1-17.26,16.72H17.74A17,17,0,0,1,.49,582.88V171.72A17,17,0,0,1,17.74,155H261.53a18,18,0,0,1,5.85,1L379.86,264.21A16.29,16.29,0,0,1,381.41,271.14Z",
    fill: "#ccf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.64,263.21h-95a17.2,17.2,0,0,1-17.43-17V155Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9,
    y: 371.68,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.94 1.41) rotate(-0.43)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.02,
    y: 517.27,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.04 0.94) rotate(-0.43)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.34,
    y: 299.13,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.39 1.41) rotate(-0.43)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.46,
    y: 444.23,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.48 1.42) rotate(-0.43)",
    fill: "#00a0df"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableDiaryViewEntries);
export default __webpack_public_path__ + "static/media/stable_diary_view_entries.5075042131bb867bc3481ff98e836603.svg";
export { ForwardRef as ReactComponent };